const NotFound = () => {
    return (
        <div className='content not-found'>
            <p>☁︎ 404 ☂︎</p>
        </div>
    )
}

export default NotFound